const queryKeys = {
  all: (partyId: string) => ['invoices', partyId],

  lists: (partyId: string) => [...queryKeys.all(partyId), 'list'],
  details: (partyId: string) => [...queryKeys.all(partyId), 'detail'],

  list: (partyId: string, filter: unknown) => [
    ...queryKeys.lists(partyId),
    filter,
  ],

  byId: (partyId: string, id: string) =>
    [...queryKeys.details(partyId), id] as const,
};

export default queryKeys;
